<app-sbeditor-tool-logo #logo ></app-sbeditor-tool-logo>
<app-sbeditor-tool-favicon #favicon></app-sbeditor-tool-favicon>
